// Where we have an iframe wrapped in a figure (i.e. in a RTE block)
// add a responsive class to the figure element
document.querySelectorAll("iframe").forEach((iframe) => {
    const parentEl = iframe.parentElement;

    if (parentEl.nodeName.toLowerCase() === "figure") {
        // Calculate accurate padding value to apply to parent element
        const aspectRatio = `${
            (iframe.clientHeight / iframe.clientWidth) * 100
        }%`;

        const wrapper = document.createElement("div");

        // Wrap video parent in new element
        parentEl.before(wrapper);
        wrapper.append(parentEl);

        // Scale portrait iframes slightly differently
        if (iframe.clientHeight / iframe.clientWidth > 1.5) {
            wrapper.classList.add("responsive-iframe--portrait");
        } else {
            wrapper.classList.add("responsive-iframe");
        }

        parentEl.style.paddingBottom = aspectRatio;
    }
});
